<!-- components/Survey/ProgressBar.svelte -->
<script>
  // Import the Cavs logo directly
  import cavsLogo from '../../assets/images/cavs_logo.png';
  
  // Change these to match what's being passed from SurveyContainer
  export let currentStep;
  export let totalSteps;
  
  // Calculate position percentage for basketball
  $: basketballPosition = (currentStep / totalSteps) * 100;
</script>

<div class="progress-container">
  <!-- Progress line and dots -->
  <div class="progress-bar">
    <!-- Background line -->
    <div class="line-bg"></div>
    
    <!-- Filled line -->
    <div class="line-fill" style="width: {basketballPosition}%"></div>
    
    <!-- All steps as dots, including the last one -->
    {#each Array(totalSteps + 1).fill().map((_, i) => i) as i}
      <div 
        class="dot" 
        class:completed={i < currentStep} 
        class:future={i > currentStep}
        class:hidden={i === currentStep} 
        style="left: {(i / totalSteps) * 100}%"
      ></div>
    {/each}
    
    <!-- Cavs logo positioned after the last dot -->
    <div class="trophy">
      <img src={cavsLogo} alt="Cavs Logo" class="cavs-logo">
    </div>
    
    <!-- Basketball emoji as current position indicator -->
    <div class="basketball-indicator" style="left: {basketballPosition}%">
      🏀
    </div>
  </div>
</div>

<style>
  .progress-container {
    width: 90%;
    max-width: 600px;
    margin: 0 auto;
    padding: 0.5rem 0;
    margin-top: 0.5rem;
    /* margin-bottom: 1.5rem; */
  }
  
  .progress-bar {
    position: relative;
    height: 40px;
    width: 100%;
    margin-bottom: 5px;
  }
  
  /* Background line */
  .line-bg {
    position: absolute;
    width: 100%;
    height: 3px;
    background-color: #e0e0e0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }
  
  /* Filled line */
  .line-fill {
    position: absolute;
    height: 3px;
    background-color: #6A0032; /* Cavs wine */
    top: 50%;
    transform: translateY(-50%);
    transition: width 0.5s ease;
    z-index: 2;
  }
  
  /* Step dots */
  .dot {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    z-index: 3;
    transition: all 0.3s ease;
  }
  
  /* Completed dots */
  .completed {
    background-color: #6A0032; /* Cavs wine */
  }
  
  /* Future dots */
  .future {
    background-color: #e0e0e0;
  }
  
  /* Hide the dot where the basketball is */
  .hidden {
    opacity: 0;
  }
  
  /* Trophy/Cavs logo positioned after the last dot */
  .trophy {
    position: absolute;
    right: -40px; /* Moved further to the right as requested */
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;
    opacity: 0.9;
    transition: opacity 0.3s ease;
  }
  
  /* Cavs logo styling */
  .cavs-logo {
    width: 30px;
    height: auto;
  }
  
  /* Make trophy/logo more vibrant when close to completion */
  .progress-bar:hover .trophy {
    opacity: 1;
  }
  
  /* Basketball indicator */
  .basketball-indicator {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 24px;
    line-height: 1;
    z-index: 4;
    transition: left 0.5s ease;
    animation: bounce .5s infinite alternate;
    filter: drop-shadow(0 2px 2px rgba(0,0,0,0.2));
  }
  
  /* Bounce animation for the basketball */
  @keyframes bounce {
    0% {
      transform: translate(-50%, -50%);
    }
    100% {
      transform: translate(-50%, -70%);
    }
  }
</style>